// export * from "./welcome/welcome-screen"
// export * from "./demo/demo-screen"
// export * from "./demo/demo-list-screen"
export * from "./error/error-boundary"
// export other screens here
// export * from "./login/splash/splash-screen"
// export * from "./login/onboard/onboard-screen"
// export * from "./login/social-login/social-login-screen"
// export * from "./login/login/login-screen"
// export * from "./login/password-reset/password-reset-screen"
// export * from "./login/register/register-screen"

// export * from "./home/auto-feeder-pond/auto-feeder-pond-create/auto-feeder-pond-create-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-pond-detail/auto-feeder-pond-detail-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-pond-edit/auto-feeder-pond-edit-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-pond-activity-list/auto-feeder-pond-activity-list-screen"
// export * from "./home/chemical-multi-measurement/chemical-multi-measurement-create/chemical-multi-measurement-create-screen"
// export * from "./home/cycle/cycle-detail/cycle-detail-screen"
// export * from "./home/cycle/cycle-close/cycle-close-screen"
// export * from "./home/cycle/cycle-close-multiple/cycle-close-multiple-screen"
// export * from "./home/cycle/cycle-graph/cycle-graph-screen"
// export * from "./home/cycle/cycle-create-multiple/cycle-create-multiple-screen"
// export * from "./home/cycle-disease/cycle-disease-create/cycle-disease-create-screen"
// export * from "./home/disease/disease-screen"
// export * from "./home/farm/farm-create/farm-create-screen"
// export * from "./home/farm/farm-auto-feeder-pond-list/farm-auto-feeder-pond-list-screen"
// export * from "./home/farm-pond/farm-pond-list/farm-pond-list-screen"
// export * from "./home/farm-shrimp-price/farm-shrimp-price-create/farm-shrimp-price-create-screen"
// export * from "./home/feed/feed-create/feed-create-screen"
// export * from "./home/feeding-tray-control/feeding-tray-control-create-multiple/feeding-tray-create-multiple-screen"
// export * from "./home/harvest/harvest-create/harvest-create-screen"
// export * from "./home/home/home-screen"
// export * from "./home/jala-web-view/jala-web-view-screen"
// export * from "./home/microbiology-multi-measurement/microbiology-multi-measurement-create/microbiology-multi-measurement-create-screen"
// export * from "./home/mortality/mortality-create/mortality-create-screen"
// export * from "./home/pond/pond-create-multiple/pond-create-multiple-screen"
// export * from "./home/pond/pond-pre-create-multiple/pond-pre-create-multiple-screen"
// export * from "./home/plankton-multi-measurement/plankton-multi-measurement-create/plankton-multi-measurement-create-screen"
// export * from "./home/sampling/sampling-create/sampling-create-screen"
// export * from "./home/shrimp-news/shrimp-news-detail/shrimp-news-detail-screen"
// export * from "./home/shrimp-news/shrimp-news-screen"
// export * from "./home/shrimp-price/shrimp-price-list/shrimp-price-list-screen"
// export * from "./home/shrimp-price/shrimp-price-detail/shrimp-price-detail-screen"
// export * from "./home/treatment/treatment-create/treatment-create-screen"
// export * from "./home/water-quality-multi-measurement/water-quality-multi-measurement-create/water-quality-multi-measurement-create-screen"
//
// export * from "./graph/graph/graph-screen"
//
// export * from "./help/help/help-screen"
//
// export * from "./initial-sync/initial-sync-screen"
//
// export * from "./monitoring/monitoring-screen"
//
// export * from "./profile/profile/profile-screen"
//
// export * from "./quick-input/quick-input/quick-input-screen"
// export * from "./profile/setting-account/setting-account-screen"
// export * from "./profile/setting-account/change-password/change-password-screen"
// export * from "./profile/setting-account/delete-account/delete-account-screen"
// export * from "./home/farm-pond/pond-profile/pond-profile-screen"
// export * from "./profile/edit-profile/edit-profile-screen"
// export * from "./profile/connected-farm/connected-farm-screen"
// export * from "./profile/connected-farm/member/member-screen"
// export * from "./profile/connected-farm/member/add-member/add-member-screen"
// export * from "./profile/info-app/info-app-screen"
// export * from "./profile/policy/policy-screen"
// export * from "./change-language/change-language-screen"
// export * from "./home/cycle/cycle-history/cycle-history-screen"
// export * from "./profile/interest/interest-screen"
// export * from "./login/verification/verification-screen"
// export * from "./home/shrimp-price/create-shrimp-price-first/create-shrimp-price-first-screen"
// export * from "./home/shrimp-price/create-shrimp-price-second/create-shrimp-price-second-screen"
// export * from "./home/disease/disease-detail/disease-detail-screen"
// export * from "./notifications/FarmingNotification-screen"
// export * from "./notifications/InfoNotification-screen"
// export * from "./home/finance/finance-screen"
// export * from "./home/simulation/simulation-list/simulation-list-screen"
// export * from "./home/simulation/simulation-create/simulation-create-screen"
// export * from "./home/simulation/simulation-harvest/simulation-harvest-screen"
// export * from "./home/simulation/simulation-feed/simulation-feed-screen"
// export * from "./home/simulation/simulation-biomass/simulation-biomass-screen"
// export * from "./home/cycle/cycle-create-multiple/custom-fr-table/custom-fr-table-screen"
// export * from "./home/parameter-list/parameter-list-screen"
// export * from "./home/activity/cycle-to-do-list/cycle-to-do-list-screen"
// export * from "./home/activity/cycle-to-do-settings/cycle-to-do-settings-screen"
// export * from "./home/farm-shrimp-price/farm-private-selling-price-create/farm-private-selling-price-create-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-create-qr-scan/auto-feeder-create-qr-scan-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-create-wizard/wizard-conection-setup-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-create-wizard/wizard-conection-setup-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-create-wizard/wizard-mode-setup-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-create-wizard/wizard-test-run-screen"
// export * from "./home/chemical-measurement-prediction/chemical-measurement-prediction-list-screen"
// export * from "./home/chemical-measurement-prediction/chemical-measurement-prediction-detail-screen"
// export * from "./home/goto-jala-pro/goto-jala-pro-screen"
// export * from "./home/auto-feeder-pond/auto-feeder-pond-daily-feed-create-multiple/auto-feeder-pond-daily-feed-create-multiple-screen"
// export * from "./graph/graph/farming-graph/farming-graph-screen"
// export * from "./graph/graph/water-quality-graph/water-quality-graph-screen"
// export * from "./graph/graph/cost-analysis-graph/cost-analysis-graph-screen"
//
// export * from "./scratch/scratch-screen"

export * from "./quiz/start/start-screen"
export * from "./quiz/question/question-detail/question-detail-screen"
export * from "./quiz/question/question-with-answer-detail/question-with-answer-detail-screen"
export * from "./quiz/result/result-screen"
